import { render, staticRenderFns } from "./AdminCreateTicketDialog.vue?vue&type=template&id=1bf6c5ca&"
import script from "./AdminCreateTicketDialog.vue?vue&type=script&lang=ts&"
export * from "./AdminCreateTicketDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports